import axios from "axios";
import { apiRoute, baseUrl } from "../util/constant";

export const clearServerSession = async () => {
    try {
        await axios.get(`${baseUrl}${apiRoute.logout}`, { withCredentials: true });
    } catch (error) {
        // A missing/expired server session should not block local cleanup.
    }
};

export const clearSessionCache = async () => {
    try {
        const { persistor } = await import("../store/store");
        await persistor.purge();
    } catch (error) {
        // Keep logout resilient even if redux-persist cleanup fails.
    }

    try {
        localStorage.clear();
        sessionStorage.clear();
    } catch (error) {
        // Storage can be unavailable in some browser privacy modes.
    }
};
